<script>
    import GuidedOfferCampaignCard from './GuidedOfferCampaignCard/src/lib/components/GuidedOfferCampaignCard/GuidedOfferCampaignCard.svelte';

    export let config;
</script>

<GuidedOfferCampaignCard {config} />
